<template>
    <program-sponsor-joboffers />
</template>

<script>
import ProgramSponsorJoboffers from '@/views/Employee/ProgramComponents/ProgramDetails/ProgramSponsors/ProgramSponsorDetails/ProgramSponsorJoboffers.vue'

export default {
    name: "AupairSponsorJobOffers",
    components: { ProgramSponsorJoboffers }
}
</script>